<template>
  <div>
    <div class="parent" :class="[!showDetails ? 'parent-2' : '']">
      <v-card @click="showCoursefun">
        <v-card-title class="info-title">
          <div class="text-center">
            {{ cycle.CycleName }}
          </div>
        </v-card-title>
        <div>
          <app-row
            icon="calendar-alt"
            title="تاریخ شروع:"
            :value="cycle.D_Start"
          />
           <app-row
            icon="calendar-alt"
            title="تاریخ پایان:"
            :value="cycle.D_End"
          />
           <app-row
            icon="arrows-alt-h"
            title="بازه نمره قابل اعتراض:"
            :value="cycle.EterazMin + ' تا ' + cycle.EterazMax"
          />
         
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["cycle", "index", "showDetails"],
  components: {
    appRow: DetailRow,
  },

  methods: {
    showCoursefun() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
  },
};
</script>


